import React, {Component} from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@material-ui/core"

import api from "../../api.js"

import ErrorMessageDialog from "../../ui/ErrorMessageDialog.js"

import FolderList from "./FolderList"

/**
 * exclude - папка которую нельзя выбрать. Нужно, что бы предотвратить возможность копировать папку в саму себя.
 * folder_id - id папки с которой нужно начать отображение выбора.
 * 
 * onSelectClick(folder_id)
 * onCancelClick
 */

class SelectFolderDialog extends Component {

    constructor(props) {

        super(props)

        this.ROOT_FOLDER_NAME = "Корневой каталог"

        this.state = {
            dialog: undefined,
            selected: undefined,
            folder_id: this.props.folder_id,
            parent_folder_name: this.ROOT_FOLDER_NAME,
            templates: [],
        }

        this.handle_error = this.handle_error.bind(this)
        this.update = this.update.bind(this)

    }

    /**
     * Диалог сообщения о ошибке.
     * 
     * @param {string|Error} error - ошибка.
     */

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
                        .then(() => this.setState({dialog: undefined}))
                        .catch(this.handle_error)
				}}
			/>
		})
	}    

    async componentDidMount() {
        await this.update()
            .catch(this.handle_error)
    }

    /**
     * Обновление состояния.
     */

    async update() {
        const response = await api.purchases_templates.list(this.state.folder_id)
        this.setState({templates: response})
    }

    render() {

        return <Dialog
            open
            fullWidth 
            onClick = {e => {
                e.stopPropagation()
                this.setState({selected: undefined})
            }}
        >
            <DialogTitle>Выбрать папку: {this.state.selected ? this.state.selected.name : this.state.parent_folder_name}</DialogTitle>
            <DialogContent>
                <FolderList
                    items = {this.state.templates}
                    selected = {this.state.selected}
                    folder_id = {this.state.folder_id}
                    exclude = {this.props.exclude}
                    onClickItem = {template => this.setState({selected: template})}
                    onDoubleClickItem = {template => {
                        if (this.props.exclude) {
                            if (this.props.exclude.id == template.id) {
                                return
                            }
                        }
                        this.setState({
                            folder_id: template.id,
                            parent_folder_name: template.name
                        }, async () => await this.update().catch(this.handle_error))
                    }}
                    onBackClick = {() => {
                        api.purchases_templates.get(this.state.folder_id)
                            .then(template => this.setState({folder_id: template.folder_id}))
                            .then(async () => {
                                if (this.state.folder_id) {
                                    let parent_folder = await api.purchases_templates.get(this.state.folder_id)
                                    this.setState({parent_folder_name: parent_folder.name})
                                } else {
                                    this.setState({parent_folder_name: this.ROOT_FOLDER_NAME})
                                }
                            })
                            .then(this.update)
                            .catch(this.handle_error)
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {this.props.exclude && this.state.selected ? this.props.exclude.id == this.state.selected.id : false}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onSelectClick === "function") {
                            this.props.onSelectClick(this.state.selected ? this.state.selected.id : this.state.folder_id)
                        }
                    }}
                >Выбрать</Button>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>

    }
}

export default SelectFolderDialog